import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


const gsapAnimations = () => {
  const selectors = ['.farmstand-homepage-hero', '.farmstand-primary-page-hero', '.farmstand-image-with-text', '.farmstand-newsletter-signup', '.farmstand-related-posts', '.farmstand-testimonial-banner', '.submit-case-banner', '.media-banner', '.farmstand-accordion-section', '.angled-section'];

  if (!Array.isArray(selectors) || !selectors.length) return;

  const elements = document.querySelectorAll(selectors.join(", "));
  if (!elements.length) return;

  elements.forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      start: "top 70%",
      end: "bottom top",
      onEnter: () => el.classList.add("in-view"),
      onLeave: () => el.classList.remove("in-view"),
      onEnterBack: () => el.classList.add("in-view"),
      onLeaveBack: () => el.classList.remove("in-view"),
    });
  });
};

const gsapFadeInUp = () => {
  const selectors = [];

  if (!Array.isArray(selectors) || !selectors.length) return;

  const elements = document.querySelectorAll(selectors.join(", "));
  if (!elements.length) return;

  elements.forEach((el) => {
    gsap.set(el, { opacity: 0, y: 30 });

    ScrollTrigger.create({
      trigger: el,
      start: "top 75%",
      onEnter: () => {
        gsap.to(el, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: "power2.out",
        });
      },
      onLeaveBack: () => {
        gsap.set(el, { opacity: 0, y: 30 });
      },
    });
  });
};

export { gsapAnimations, gsapFadeInUp };